__turbopack_context__.v({
  "calendar": "Calendar-module__oaXR6q__calendar",
  "day": "Calendar-module__oaXR6q__day",
  "head": "Calendar-module__oaXR6q__head",
  "today": "Calendar-module__oaXR6q__today",
});
